import api, { GetApiReturn, GetApiReturnError, ValidateAxiosError } from '@/modules/api.service';
import { Endpoints } from '@/shared/constants/endpoints';
import { ReadMovimentacaoTipoDto, CreateMovimentacaoTipoDto, UpdateMovimentacaoTipoDto } from '@/api.types';

export async function LerTipoMovimentacoes(
  skip: number,
  take: number,
  nucleo: boolean = false,
) {
  return api
    .get(Endpoints.MOVIMENTACAOTIPO, {
      params: { skip: skip, take: take, where: 'nucleo =' + nucleo },
    })
    .then((response) => {
      return GetApiReturn<ReadMovimentacaoTipoDto>(
        response.data as Array<ReadMovimentacaoTipoDto>,
      );
    })
    .catch((error) => {
      ValidateAxiosError<ReadMovimentacaoTipoDto>(error, 'Falha ao listar objetos.');
      return GetApiReturnError<ReadMovimentacaoTipoDto>();
    });
}

export async function LerTipoMovimentacao(id: number) {
  return api
    .get<ReadMovimentacaoTipoDto>(Endpoints.MOVIMENTACAOTIPO + '/' + id)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return ValidateAxiosError<ReadMovimentacaoTipoDto>(
        error,
        'Falha ao bucar objeto.' + id,
      );
    });
}

export async function AtualizarTipoMovimentacao(tipo: CreateMovimentacaoTipoDto | UpdateMovimentacaoTipoDto) {
  if (tipo.id !== null && tipo.id != undefined && tipo.id > 0) {
    return api
      .put(Endpoints.MOVIMENTACAOTIPO + '/' + tipo.id, tipo as UpdateMovimentacaoTipoDto)
      .then(() => {
        return 'Tipo ' + (tipo as ReadMovimentacaoTipoDto).descricao + ' atualizada.';
      })
      .catch((error) => {
        return ValidateAxiosError<string>(error, 'Falha ao atualizar objeto.');
      });
  } else {
    return api
      .post(Endpoints.MOVIMENTACAOTIPO, tipo as CreateMovimentacaoTipoDto)
      .then(() => {
        return 'Tipo ' + (tipo as CreateMovimentacaoTipoDto).descricao + ' cadastrada.';
      })
      .catch((error) => {
        return ValidateAxiosError<string>(error, 'Falha ao cadastrar objeto.');
      });
  }
}

export async function ExcluirTipoMovimentacao(id: number) {
  return api
    .delete(Endpoints.MOVIMENTACAOTIPO + '/' + id)
    .then(() => {
      return 'Tipo removido.';
    })
    .catch((error) => {
      return ValidateAxiosError<string>(error, 'Falha ao remover objeto.');
    });
}
